module.exports = __webpack_public_path__ + "static/media/logo-dapper.145bcd0f.svg";